<div class="approve-user-modal">
    <div class="kiktemp-loader" *ngIf="isGettingData">
        <img src="assets/img/kikblox_logo_rounded.webp" class="spinner" />
        <div class="loading-text">Loading...</div>
    </div>

    <div *ngIf="!isGettingData && loadFailed" class="load-error">
        Could not load this request's details. Please close and try again.
    </div>

    <div *ngIf="!isGettingData && !loadFailed">
        <p class="modal-subtext">
            Approving <strong>{{selectedUserName}}</strong> ({{requestData.organizationName}}). Choose the account type
            to grant access.
        </p>

        <div class="flex flex-column gap-2 input-container">
            <label>User Type <span class="required">*</span></label>
            <p-dropdown [options]="userTypes" optionLabel="name" placeholder="Select a user type"
                [(ngModel)]="selectedUserType" styleClass="custom-drop-down" [appendTo]="'body'"
                [autoDisplayFirst]="false" [panelStyleClass]="'approve-user-dropdown-panel'">
            </p-dropdown>
        </div>

        <div class="modal-actions">
            <button class="cancel-btn" (click)="cancel()" [disabled]="isSaving">Cancel</button>
            <button class="save-btn" (click)="save()" [disabled]="!selectedUserType || isSaving">
                {{ isSaving ? 'Saving...' : 'Approve & Save' }}
            </button>
        </div>
    </div>
</div>